/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Tabs} from "antd";
import {BaechaList2TableItem} from "../BaechaList2.interface";
import TabBaechaWorkDay from "./Tabs/TabBaechaWorkDay/TabBaechaWorkDay";
import TabBaechaUpdateHistory from "./Tabs/TabBaechaUpdateHistory/TabBaechaUpdateHistory";
import TabCallPass from "./Tabs/TabCallPass/TabCallPass";
import TabChat from "./Tabs/TabChat/TabChat";
import TabPrivateInfo from "./Tabs/TabPrivateInfo/TabPrivateInfo";
import TabPhotosAfterWorkDone from "./Tabs/TabPhotosAfterWorkDone/TabPhotosAfterWorkDone";
import TabEtc from "./Tabs/TabEtc/TabEtc";

interface ExpandedBaechaRowProps {
	data?: BaechaList2TableItem;
}

const ExpandedBaechaRow = ({ data }: ExpandedBaechaRowProps) => {
	const [activeKey, setActiveKey] = useState('detail');

	return (
		<div style={{ padding: 16, background: '#fafafa' }}>
			<Tabs
				activeKey={activeKey}
				onChange={setActiveKey}
				destroyInactiveTabPane
				items={[
					...(
						(data?.privateAddress || data?.privateNote || data?.privatePhoneNum)
							? [{
								key: 'privateInfo',
								label: '수주자에게만 공개',
								children: data ? <TabPrivateInfo data={data}/> : null,
							}]
							: []
					),
					{
						key: 'detail',
						label: '작업 상세',
						children: data ? <TabBaechaWorkDay data={data}/> : null,
					},
					{
						key: 'history',
						label: '작업 이력',
						children: <TabBaechaUpdateHistory baechaId={data?.id}/>,
					},
					{
						key: 'callPass',
						label: '콜/패스',
						children: <TabCallPass data={data}/>,
					},
					{
						key: 'chat',
						label: '채팅',
						children: (
							<TabChat
								baechaId={data?.id}
								baljuMemberId={data?.baljuMemberId}
								sujuMemberId={data?.sujuMemberId}
							/>
						),
					},
					{
						key: 'etc',
						label: '기타',
						children: data
							? <TabEtc data={data}/>
							: null,
					},
				]}
			/>
		</div>
	);
};

export default ExpandedBaechaRow;
